// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__NMUxp","detailsBorder":"styles_detailsBorder__Bmg0H"};